import { SignaturesModel } from '../models/signatures.model';
import { ConfigurationModel } from '../models/configuration.model';
import { AppService } from '../app.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestrictionModel } from '../models/restriction.mode';

@Injectable()
export class ConfigurationService extends AppService<ConfigurationModel> {

  constructor(http: HttpClient) {
    super(http);
  }

  async update(configuration: ConfigurationModel) {
    const result = await this.putAsync(`Configuration/Dependent/${configuration.dependent.id}`, configuration);
    return result;
  }

  async getCompany(id: string) {
    const result = await this.getAsync(`Configuration/company/${id}`);
    return result;
  }

  async updateSignature(id: string, signature: SignaturesModel) {
    const result = await this.putAsync(`Configuration/Dependent/${id}/signature`, signature);
    return result;
  }

  async removeSignature(id: string, signature: SignaturesModel) {
    const result = await this.putAsync(`Configuration/Dependent/${id}/signature/${signature.id}/remove`, signature);
    return result;
  }

  async getRestriction(id: string) {
    const result = await this.getAsync(`Restrictions/${id}`);
    return result;
  }

  async updateRestriction(id: string, restrictions: RestrictionModel[]) {
    const result = await this.putAsync(`Restrictions/${id}`, restrictions);
    return result;
  }

  async get(id: string) {
    const result = await this.getAsync(`Configuration/Dependent/${id}`);
    return result;
  }

  async getFromMeepServer(id: string) {
    const result = await this.getAsync(`Configuration/Dependent/${id}`);
    return result;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/configuration.service.ts